import React, { Component} from 'react';
import ProductModalContextComponent from '../modals/product/ProductModalContextComponent';
import { ProductModalContext } from '../modals/product/ProductModalContext';
import ProductModal from '../modals/product/extended-product-modal/ui/ProductModal';
import TemplateProductModal from '../modals/product/TemplateProductModal/TemplateProductModal';


class ProductViewNew extends Component {
    constructor(props) {
        super(props);
        this.onProductTitleLoaded = this.onProductTitleLoaded.bind(this);
        this.mounted = false;
        this.productTitle = null;
    }

    componentDidMount() {
        this.mounted = true;
        
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    onProductTitleLoaded(productTitle) {
        this.productTitle = productTitle;
    }

    render() {
        const { productSKU, specialUrl, isShowingProductModal, onProductModalClose } = this.props;
        return (
            <ProductModalContextComponent ProductSKU={productSKU}
            onProductTitleLoaded={this.onProductTitleLoaded}>
                <div>
                <ProductModalContext.Consumer>
                        {value => {
                            const isLoading = !(!value.isStylingLoading  && !value.isLoading);
                            if(!isShowingProductModal) return false;
                            
                            return value.expandedProduct && value.thumbnailUrls ?(
                                !isLoading ?
                                    <ProductModal
                                        sku={productSKU}
                                        onClose={onProductModalClose}
                                        specialUrl={specialUrl}
                                    /> : null) : null
                            }
                        }
                    </ProductModalContext.Consumer>
                </div>
            </ProductModalContextComponent>
        );
    }
}

export default ProductViewNew;